export const UserPropertyType = {
    userStaticList: 'userStaticList',
    userPathway: 'userPathway',
    userManagement: 'userManagement',
    userSupportTeam: 'userSupportTeam',
    userSymptom: 'userSymptom',
    symptomsPathway: 'symptomsPathway',
    generalPractitioner: 'generalPractitioner',
}
